import {useApiQuery, type QueryResult} from 'src/hooks/useApiQuery';
import type {AirCardResponse} from 'src/types/ai-team';


export const useAiRecruiterCard = (): QueryResult<AirCardResponse> =>
  useApiQuery<AirCardResponse>('homepage/air_card', {
    apiOptions: {options: {apiPath: '/bff/api/v1/'}},
    queryOptions: {queryKey: ['homepage', 'air_card']},
  });
